import React from "react";
import "./Table.scss";

/**
 * Main Table wrapper component.
 * Distributes column count to its children via props.
 */
export const Table = ({ children, columns = 4, className }) => {
  return (
    <div className={`custom-table ${className}`}>
      {React.Children.map(children, (child) =>
        // Clone each child and inject the number of columns
        React.cloneElement(child, { columns })
      )}
    </div>
  );
};

/**
 * TableHeader component.
 * Lays out the header cells in a CSS grid based on column count.
 */
export const TableHeader = ({ children, columns }) => {
  return (
    <div
      className="custom-table-header"
      style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }} // Dynamic column layout
    >
      {children}
    </div>
  );
};

/**
 * TableRow component.
 * Each row of the table, styled with grid layout matching column count.
 */
export const TableRow = ({ children, columns }) => {
  return (
    <div
      className="custom-table-row"
      style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }} // Dynamic column layout
    >
      {children}
    </div>
  );
};

/**
 * TableCell component.
 * Single cell of the table, can optionally be styled as a header cell.
 */
export const TableCell = ({ children, header = false }) => {
  return (
    <div className={`custom-table-cell ${header ? "header-cell" : ""}`}>
      {children}
    </div>
  );
};
